import { LOAD_JOB_PAYLOAD_SUCCESS, CLEAR_PAYLOAD } from '../../actions/types';

const INITIAL_STATE = '';

export default (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_JOB_PAYLOAD_SUCCESS:
            return action.payload;
        case CLEAR_PAYLOAD:
            return action.payload;
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/jobhistory/JobPayloadReducer.js